import React from 'react';

import { isLocalURL } from '$utilities/browser';
import { formatLinkBlockToUrl } from '$utilities/format';
import { usePage } from '$contexts/page.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PanelBasicHalfBlock}
 */
const PanelBasicHalf = ({
    backgroundColor,
    buttons,
    id,
    image,
    prevType,
    text,
    title
}) => {
    const { page } = usePage();

    const bgColor = `bg-surface-panel-${backgroundColor}`;

    return (
        <section className={`${prevType === 'PanelBasicHalfBlock' ||  prevType === 'PanelTagsBlock' ? 'col-wrapper-breakout' : 'col-wrapper-breakout-half'} ${bgColor} rounded-lg flex-grow sm:flex-grow-0 w-full sm:w-1/2 relative`}>
            <div className={`${bgColor} w-full h-full rounded-lg col-padding pt-24 pb-16 sm:-mx-4 md:-mx-8`}>
                <h2 className='type-style-sans-h1 w-full relative z-10'>
                    {title}
                </h2>

                {text && (
                    <p className='type-style-sans-h3 mt-8 w-full md:w-5/6 relative z-10'>
                        {text}
                    </p>
                )}

                {buttons?.length > 0 && (
                    <div className='mt-24 sm:mt-40 flex flex-wrap gap-x-8 relative z-10'>
                        {buttons.map((button, idx) => {
                            const isCtaLinkLocal = isLocalURL(formatLinkBlockToUrl(button.ctaLink));

                            return (
                                <React.Fragment key={idx}>
                                    {button.ctaMobileUrlOverride ? (
                                        <>
                                            <a
                                                className={`sm:hidden ${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}`}
                                                data-analytics-action='click'
                                                data-analytics-context={title}
                                                data-analytics-destination={button.ctaMobileUrlOverride}
                                                data-analytics-id={`${page?.id}_${id}_panel_basic_half_cta_${idx}`}
                                                data-analytics-label={button.ctaLabel}
                                                data-analytics-location='modules'
                                                data-analytics-module='panel_basic_half_cta'
                                                href={button.ctaMobileUrlOverride}
                                                rel='noreferrer'
                                                target='_blank'>
                                                {button.ctaLabel}
                                            </a>
                                            <a
                                                className={`hidden sm:inline-block ${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}${button.ctaCssClass ? ' ' + button.ctaCssClass : ''}`}
                                                data-analytics-action='click'
                                                data-analytics-context={title}
                                                data-analytics-destination={formatLinkBlockToUrl(button.ctaLink)}
                                                data-analytics-id={`${page?.id}_${id}_panel_basic_half_cta_${idx}`}
                                                data-analytics-label={button.ctaLabel}
                                                data-analytics-location='modules'
                                                data-analytics-module='panel_basic_half_cta'
                                                href={formatLinkBlockToUrl(button.ctaLink)}
                                                rel={isCtaLinkLocal ? undefined : 'noreferrer'}
                                                target={isCtaLinkLocal ? undefined : '_blank' }>
                                                {button.ctaLabel}
                                            </a>
                                        </>
                                    ) : (
                                        <a
                                            className={`${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}${button.ctaCssClass ? ' ' + button.ctaCssClass : ''}`}
                                            data-analytics-action='click'
                                            data-analytics-context={title}
                                            data-analytics-destination={formatLinkBlockToUrl(button.ctaLink)}
                                            data-analytics-id={`${page?.id}_${id}_panel_basic_half_cta_${idx}`}
                                            data-analytics-label={button.ctaLabel}
                                            data-analytics-location='modules'
                                            data-analytics-module='panel_basic_half_cta'
                                            href={formatLinkBlockToUrl(button.ctaLink)}
                                            rel={isCtaLinkLocal ? undefined : 'noreferrer'}
                                            target={isCtaLinkLocal ? undefined : '_blank' }>
                                            {button.ctaLabel}
                                        </a>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </div>
                )}
            </div>

            {image && (
                <div
                    className='absolute top-0 w-full h-full rounded-lg overflow-hidden bg-cover bg-bottom-right z-0 mix-blend-multiply'
                    style={{
                        backgroundImage: `url(${image.image?.src})`
                    }}>
                </div>
            )}
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PanelBasicHalf;
